import { Component } from 'react';
import Security from '../components/Security';
import UserPreferencesPage from './UserPreferencesPage';
import { jsx as _jsx } from "react/jsx-runtime";
class SecurityContainer extends Component {
  render() {
    return /*#__PURE__*/_jsx(UserPreferencesPage, {
      loadWithErrors: true,
      children: /*#__PURE__*/_jsx(Security, {})
    });
  }
}
export default SecurityContainer;